import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FormItemProps } from 'antd/lib/form';
import { CustomDatePickerWrapper, CustomDatePickerWrapperProps, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomDatePickerWrapperProps &
    Pick<FormItemProps, 'normalize'> & {
        message?: string;
    };

const GenericDatePicker: InputWithMeta<Props> = (props: Props) => {
    const { input, message, normalize, ...rest } = props;

    return (
        <CustomFormItem
            name={input.guid}
            required={input.required}
            message={message}
            isReadOnly={input.isReadOnly}
            normalize={normalize}
        >
            <CustomDatePickerWrapper input={input} topRightNode={<InputControls input={input} />} {...rest} />
        </CustomFormItem>
    );
};

GenericDatePicker.meta = {
    inputType: InputModel.name
};

export default observer(GenericDatePicker);
